import React from "react";
import { AppColors } from "../resources/AppColors";
import { Button, Tooltip } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import { AppTextsFontSize, textType } from "../resources/AppTexts";
import PropTypes from "prop-types";
import TextMonitoring from "./TextMonitoring";
import { IconContext } from "react-icons";

const StudiesToolTip = withStyles({
  tooltip: {
    color: AppColors.BLACK,
    backgroundColor: AppColors.WHITE,
    fontSize: AppTextsFontSize.SIZE_BODY,
  },
})(Tooltip);

const ButtonMonitoring = ({
  backGroundColor,
  width,
  color,
  size,
  onClick,
  isDisabled,
  text,
  textAlign,
  icon,
  marginLeft,
  margin,
  buttonTextType,
  variant,
  border,
  ...other
}) => {
  if (isDisabled == null) isDisabled = false;
  if (backGroundColor == null) backGroundColor = AppColors.PRIMARY;
  if (color == null) color = AppColors.WHITE;
  if (textAlign == null) textAlign = "center";
  if (buttonTextType == null) buttonTextType = textType.BODY_BOLD;
  if (variant == null) variant = "contained";

  return (
    <Button
      variant={variant}
      size={size}
      style={{
        boxShadow: "3px 3px 3px 1px rgba(0,0,0,.16)",
        border: border,
        width: width,
        paddingTop: 0,
        paddingBottom: 0,
        backgroundColor: backGroundColor,
      }}
      disabled={isDisabled}
      onClick={onClick}
      data-cy="login-button"
      {...other}
    >
      {icon && (
        <IconContext.Provider value={{ color: AppColors.WHITE }}>
          {icon}
        </IconContext.Provider>
      )}
      {text && (
        <TextMonitoring
          margin={margin}
          marginLeft={marginLeft}
          type={buttonTextType}
          text={text}
          color={color}
        />
      )}
    </Button>
  );
};

ButtonMonitoring.propTypes = {
  size: PropTypes.string,
  textAlign: PropTypes.string,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  className: PropTypes.any,
  popover: PropTypes.bool,
  textPopover: PropTypes.string,
};

export default ButtonMonitoring;
